(() => {
  if (customElements.get('c2n-header')) return;
  customElements.define('c2n-header', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const {signal} = this.abort;
      this.mobile = matchMedia('(max-width:989px)');
      this.announcement = this.querySelector('.c2n-announcement');
      this.announcePaused = matchMedia('(prefers-reduced-motion:reduce)').matches;
      const pause = this.querySelector('.c2n-announce-pause');
      const updatePause = () => {
        this.announcement.classList.toggle('is-paused', this.announcePaused);
        pause.setAttribute('aria-pressed', String(this.announcePaused));
        pause.setAttribute('aria-label', this.announcePaused ? 'Reprendre les annonces' : 'Mettre les annonces en pause');
        pause.firstElementChild.textContent = this.announcePaused ? '▶' : 'Ⅱ';
      };
      updatePause();
      pause.addEventListener('click', () => {this.announcePaused = !this.announcePaused; updatePause();}, {signal});
      this.menu = this.querySelector('.c2n-menu');
      this.toggle = this.querySelector('.c2n-menu-toggle');
      this.overlay = this.querySelector('.c2n-backdrop');
      this.details = [...this.querySelectorAll('.c2n-universe')];
      this.toggle.addEventListener('click', () => this.openMobile(), {signal});
      this.querySelector('[data-menu-close]').addEventListener('click', () => this.closeAll(true), {signal});
      this.overlay.addEventListener('click', () => this.closeAll(true), {signal});
      this.querySelectorAll('[data-nav-back]').forEach(b => b.addEventListener('click', () => {
        const d = b.closest('details'); d.open = false; d.querySelector('summary').focus();
      }, {signal}));
      this.details.forEach(d => {
        d.addEventListener('toggle', () => {
          d.querySelector('summary').setAttribute('aria-expanded', String(d.open));
          if (d.open) this.details.filter(other => other !== d).forEach(other => other.open = false);
          this.updateOverlay();
        }, {signal});
        d.addEventListener('pointerenter', e => {
          if (this.mobile.matches || e.pointerType !== 'mouse') return;
          clearTimeout(this.closeTimer); clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => {d.open = true;}, 150);
        }, {signal});
        d.addEventListener('pointerleave', () => {
          clearTimeout(this.openTimer);
          if (!this.mobile.matches) this.closeTimer = setTimeout(() => { if (!d.contains(document.activeElement)) d.open = false; }, 220);
        }, {signal});
      });
      this.addEventListener('keydown', e => {
        if (e.key === 'Escape') { const active = this.details.find(d => d.open); this.closeAll(this.mobile.matches); if(active && !this.mobile.matches) active.querySelector('summary').focus(); }
        if (e.key === 'Tab' && this.classList.contains('is-mobile-open')) {
          const focusable = [...this.menu.querySelectorAll('a[href],button,summary')].filter(el => el.getClientRects().length);
          const first=focusable[0],last=focusable.at(-1);
          if(e.shiftKey && document.activeElement===first){e.preventDefault();last?.focus();}
          else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first?.focus();}
        }
      }, {signal});
      document.addEventListener('click', e => { if (!this.contains(e.target)) this.closeAll(false); }, {signal});
      document.addEventListener('focusin', e => { if (!this.mobile.matches && !this.contains(e.target)) this.closeAll(false); }, {signal});
      this.mobile.addEventListener('change', () => this.closeAll(false), {signal});
      window.addEventListener('resize', () => this.updateOverlay(), {signal});
      this.resize = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--header-height', `${this.getBoundingClientRect().height}px`);
        document.documentElement.classList.remove('no-header-height'); this.updateOverlay();
      }); this.resize.observe(this);
    }
    updateOverlay(){
      this.overlay.hidden = !(this.classList.contains('is-mobile-open') || (!this.mobile.matches && this.details.some(d=>d.open)));
      this.style.setProperty('--c2n-header-bottom',`${Math.max(0,this.getBoundingClientRect().bottom)}px`);
    }
    openMobile(){
      this.details.forEach(d=>d.open=false);this.classList.add('is-mobile-open');
      this.toggle.setAttribute('aria-expanded','true');this.menu.setAttribute('role','dialog');this.menu.setAttribute('aria-modal','true');this.menu.setAttribute('aria-label','Navigation Cosy2Road');
      this.previousOverflow = document.body.style.overflow;document.body.style.overflow='hidden';
      this.updateOverlay();this.querySelector('[data-menu-close]').focus();
    }
    closeAll(restore){
      clearTimeout(this.openTimer);clearTimeout(this.closeTimer);this.details.forEach(d=>d.open=false);
      if(this.classList.contains('is-mobile-open')){document.body.style.overflow=this.previousOverflow||'';this.classList.remove('is-mobile-open');}
      this.toggle.setAttribute('aria-expanded','false');this.menu.removeAttribute('role');this.menu.removeAttribute('aria-modal');this.menu.removeAttribute('aria-label');
      this.updateOverlay();if(restore)this.toggle.focus();
    }
    disconnectedCallback(){this.closeAll(false);this.abort?.abort();this.resize?.disconnect();}
  });
})();
